import * as ActionConfigurationManager from './config.actions';

export const loadOpportunity = ActionConfigurationManager.LOAD_OPPORTUNITY
